export const DESIRED_TIMES = [
  { value: 1, label: 'В ближайшее время' },
  { value: 2, label: 'В определенное время' }
 ]


// WEBPACK FOOTER //
// ./src/features/OrderDetails/components/DeliveryTimes/constants.js